module.exports = __webpack_public_path__ + "img/9788931006216.9284a26c.jpg";